module.exports = __webpack_public_path__ + "img/banner_company.793689d6.jpg";